export const COMPANY_IMAGE_EDITING = 'internal/company/IMAGE_EDITING';
export const COMPANY_IMAGE_CANCEL_EDITING = 'internal/company/IMAGE_CANCEL_EDITING';
export const COMPANY_IMAGE_SAVING = 'internal/company/IMAGE_SAVING';
export const COMPANY_IMAGE_SUCCESS = 'internal/company/IMAGE_SUCCESS';
export const COMPANY_IMAGE_FAILURE = 'internal/company/IMAGE_FAILURE';
export const UNLOAD_COMPANY_IMAGE = 'internal/company/UNLOAD_IMAGE';
